// Logo Promptivo — wariant na ciemne tło (sam wordmark + fluo kropka),
// zgodny z assets/logo/promptivo-logo-dark.svg (viewBox 0 0 300 64).
// Inline SVG, aby wordmark renderował się w Space Grotesk (font strony).
export const Logo = ({ height = 34, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 64"
    height={height}
    width={(height * 300) / 64}
    role="img"
    aria-label="Promptivo"
    className={className}
    data-testid="promptivo-logo"
  >
    <text
      x="4"
      y="44"
      fill="#F6F5F1"
      fontFamily='Manrope, Arial, sans-serif'
      fontSize="42"
      fontWeight="500"
      letterSpacing="0.3"
    >
      PROMPTIVO
    </text>
    <circle cx="286" cy="40" r="4.5" fill="#B6FF00" />
  </svg>
);
